import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
import useDidUpdateEffect from '../../../hooks/useDidUpdateEffect';
import { DEFAULT_CHAR_LIMIT, DEFAULT_CHAR_OFFSET } from './constants';
var useReviewListing = function useReviewListing() {
  var _data$productRating, _data$productRating$u, _data$product;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$structure = _ref.structure,
    structure = _ref$structure === void 0 ? {} : _ref$structure;
  var _ref2 = (structure == null ? void 0 : structure.route) || {},
    filters = _ref2.filters,
    _ref2$page = _ref2.page,
    page = _ref2$page === void 0 ? 1 : _ref2$page,
    _ref2$sortType = _ref2.sortType,
    sortType = _ref2$sortType === void 0 ? 'MORE_RELEVANT' : _ref2$sortType;
  var items = (data == null ? void 0 : (_data$productRating = data.productRating) == null ? void 0 : (_data$productRating$u = _data$productRating.userReviews) == null ? void 0 : _data$productRating$u.items) || [];
  var _useState = useState(items),
    _useState2 = _slicedToArray(_useState, 2),
    reviews = _useState2[0],
    setReviews = _useState2[1];
  var _useState3 = useState(sortType),
    _useState4 = _slicedToArray(_useState3, 2),
    sortTypeChange = _useState4[0],
    setSortTypeChannge = _useState4[1];
  var _useState5 = useState(filters),
    _useState6 = _slicedToArray(_useState5, 2),
    filtersChange = _useState6[0],
    setFiltersChange = _useState6[1];
  var getTruncateSize = function getTruncateSize(str) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_CHAR_LIMIT;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CHAR_OFFSET;
    var strSize = str == null ? void 0 : str.length;
    return strSize > limit + offset ? limit : strSize;
  };
  var changedSortType = function changedSortType(curent, newSortType) {
    return curent !== newSortType;
  };
  var changedFilters = function changedFilters(curent, newfilters) {
    return JSON.stringify(curent) !== JSON.stringify(newfilters);
  };
  var validateFilters = function validateFilters() {
    setSortTypeChannge(sortType);
    setFiltersChange(filters);
    if (changedSortType(sortTypeChange, sortType) || changedFilters(filtersChange, filters)) {
      setReviews([]);
    }
  };
  useDidUpdateEffect(function () {
    validateFilters();
    setReviews(_toConsumableArray(items));
  }, [data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.id, sortType]);
  useDidUpdateEffect(function () {
    validateFilters();
    setReviews(function (acc) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(items));
    });
  }, [page, filters]);
  return {
    getTruncateSize: getTruncateSize,
    reviews: reviews
  };
};
export default useReviewListing;